import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LegalLayout from "../components/LegalLayout";
import useSeo from "../hooks/useSeo";

export default function Terms() {
  useSeo("Terms of Service | SimplySitter", "The terms governing your use of SimplySitter, the vetted caregiver marketplace operated by Elite Swiss LLC.");

  return (
    <div>
      <Header />
      <LegalLayout title="Terms of Service" testid="terms-page">
        <p>These Terms of Service ("Terms") govern your use of simplysitter.us (the "Service"), operated by SimplySitter, a brand of Elite Swiss LLC. By using the Service, you agree to these Terms.</p>

        <h2>1. The Service</h2>
        <p>SimplySitter is a platform that connects families with vetted caregivers and household help across the United States. We provide the platform; we are not the employer of caregivers and are not a party to any agreement families and caregivers make between themselves.</p>

        <h2>2. Accounts</h2>
        <p>You must provide accurate information when creating an account and keep your login credentials secure. You are responsible for all activity that happens under your account. Caregivers must complete identity verification before applying to jobs.</p>

        <h2>3. Membership and payments</h2>
        <p>Families post jobs under a membership plan billed at $15.99 per month, with the first month free. You may cancel at any time; cancellation stops future billing but does not refund the current period. Payments are processed by Stripe.</p>

        <h2>4. Messaging and conduct</h2>
        <p>Caregivers may apply to jobs but cannot message a family until the family starts the conversation. You agree to use messaging respectfully and lawfully, and not to harass, defraud or misrepresent yourself to any other user.</p>

        <h2>5. Vetting and responsibility</h2>
        <p>We take reasonable steps to verify caregivers, but you are responsible for your own hiring decisions and for meeting with, interviewing and screening anyone you engage. SimplySitter does not guarantee the conduct of any user.</p>

        <h2>6. Prohibited use</h2>
        <p>You may not use the Service for any unlawful purpose, post false information, attempt to bypass payment, or scrape or misuse other users' data.</p>

        <h2>7. Limitation of liability</h2>
        <p>To the maximum extent permitted by law, Elite Swiss LLC is not liable for indirect or consequential damages arising from your use of the Service or from any interaction between families and caregivers.</p>

        <h2>8. Changes and termination</h2>
        <p>We may update these Terms or suspend accounts that violate them. Continued use of the Service after changes means you accept the updated Terms.</p>

        <h2>9. Contact</h2>
        <p>Questions about these Terms can be sent to <a href="mailto:hello@simplysitter.us">hello@simplysitter.us</a>.</p>

        <div className="mt-10 rounded-2xl border border-black/10 bg-[#fdfaf7] p-5 text-[14px] text-[#5a5254]">
          <p className="font-medium text-[#1f1a1b]">Elite Swiss LLC</p>
          <p>7255 Bee Ridge Road, Sarasota, FL 34245, United States</p>
          <p className="mt-1">SimplySitter is a brand of Elite Swiss LLC.</p>
        </div>
      </LegalLayout>
      <Footer />
    </div>
  );
}
